import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/base.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Elemento #root mancante');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// PWA: shell offline e asset in cache (solo in produzione, mai in dev).
// updateViaCache 'none': il controllo aggiornamenti scarica sempre sw.js dalla
// rete, anche se la CDN gli assegna un max-age (vedi DEPLOY.md).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${import.meta.env.BASE_URL}sw.js`, { updateViaCache: 'none' })
      .catch(() => undefined);
  });
}
